import React from 'react';
import { isFunction, isEmpty, omit } from 'lodash';
import { NavLink, Link } from 'react-router-dom';

const OTNavLink = (props) => {
  let { link, isExternal = false, disabled, children, ...rest } = props;

  let restForAnchor = omit(rest, ['activeClassName', 'disabled']);
  if (disabled) {
    return <a {...restForAnchor}>{children}</a>;
  }

  if (isEmpty(link)) {
    // empty link should not happen, but might. it will not work on ie11
    console.trace('empty link');
  }
  // unwrap link (this should be unnecessary but applies to some cases)
  let _link = isEmpty(link)
    ? 'javascript:void();'
    : isFunction(link)
    ? link()
    : link;

  if (isExternal) {
    return (
      <a href={_link} {...restForAnchor}>
        {children}
      </a>
    );
  } else {
    return (
      <NavLink to={_link} {...rest}>
        {children}
      </NavLink>
    );
  }
};

const OTNavButton = (props) => {
  let { children, onClick, classNames, ...rest } = props;
  return (
    <button onClick={onClick} className={classNames + ' _btn'} type="button">
      {children}
    </button>
  );
};

const OTLink = (props) => {
  let { link = null, isExternal = false, disabled, children, ...rest } = props;

  let restForAnchor = omit(rest, ['activeClassName', 'disabled', 'to']);
  if (disabled) {
    return <a {...restForAnchor}>{children}</a>;
  }

  // unwrap link (this should be unnecessary but applies to some cases)
  let _link = isFunction(link) ? link() : link;

  if (isExternal) {
    return (
      <a href={_link} target={"_blank"} {...restForAnchor}>
        {children}
      </a>
    );
  } else {
    return (
      <Link to={_link} {...rest}>
        {children}
      </Link>
    );
  }
};

export { OTLink, OTNavLink, OTNavButton };
